import { BranchFilterSession } from '@/pages/User/pages/Branches/branchFilterUi'
import { BranchTreeSession } from '@/pages/User/pages/Branches/branchTree'
import { StructureSearchSession } from '@/pages/User/pages/Home/components/StructureSearchPanel/searchPanelUi'

import { State } from '.'
import {
	UPDATE_BRANCH_FILTER,
	UPDATE_BRANCH_TREE,
	UPDATE_SETTINGS,
	UPDATE_STRUCTURE_SEARCH,
} from './constants'

interface UpdateSettings {
	payload: State
	type: typeof UPDATE_SETTINGS
}

interface UpdateStructureSearch {
	payload: Partial<StructureSearchSession>
	type: typeof UPDATE_STRUCTURE_SEARCH
}

interface UpdateBranchFilter {
	payload: Partial<BranchFilterSession>
	type: typeof UPDATE_BRANCH_FILTER
}

interface UpdateBranchTree {
	session: BranchTreeSession,
	systemId: string,
	type: typeof UPDATE_BRANCH_TREE
}

export const updateSettings = (opts: State): UpdateSettings => ({
	type: UPDATE_SETTINGS,
	payload: opts,
})

export const updateStructureSearch = (
	payload: Partial<StructureSearchSession>,
): UpdateStructureSearch => ({
	type: UPDATE_STRUCTURE_SEARCH,
	payload,
})

export const updateBranchFilter = (
	payload: Partial<BranchFilterSession>,
): UpdateBranchFilter => ({
	type: UPDATE_BRANCH_FILTER,
	payload,
})

export const updateBranchTree = (
	systemId: string,
	session: BranchTreeSession,
): UpdateBranchTree => ({
	type: UPDATE_BRANCH_TREE,
	systemId,
	session,
})

export type Actions =
	| UpdateBranchFilter
	| UpdateBranchTree
	| UpdateSettings
	| UpdateStructureSearch
